import { Button, Flex, Text } from "@dehub/theme";
import type { UseFormReturnType } from "@dehub/theme";
import { modals } from "@dehub/theme";
import { CheckIcon, FloppyDiskIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { usePermission } from "@/shared/permission";
import { message } from "@/utils/message";
import type { IFormData } from "./warehouse-form";

type Props = {
  form: UseFormReturnType<IFormData>;
  onSubmit: (values: IFormData, isConfirmed: boolean) => Promise<void> | void;
};

export function WarehouseFormActions({ form, onSubmit }: Props) {
  const { t } = useTranslation("warehouse");
  const { t: tCommon } = useTranslation("common");
  const PRT_WRH_ADD = usePermission("PRT_WRH_ADD");
  const PRT_WRH_EDIT = usePermission("PRT_WRH_EDIT");

  const disabled = !PRT_WRH_ADD.hasAccess && !PRT_WRH_EDIT.hasAccess;

  const tryValidateAndSubmit = (isConfirmed: boolean) => {
    const result = form.validate();
    if (result.hasErrors) {
      const firstError = Object.values(result.errors).find(Boolean);
      message.error(typeof firstError === "string" ? firstError : tCommon("validation.fillRequiredFields"));
      return;
    }
    onSubmit(form.values, isConfirmed);
  };

  return (
    <Flex justify="space-between" mt="sm" pt="sm" style={{ borderTop: "1px solid var(--mantine-color-gray-2)" }}>
      <Button
        size="xs"
        radius="md"
        leftSection={<FloppyDiskIcon size={14} />}
        disabled={disabled}
        onClick={() => tryValidateAndSubmit(false)}
      >
        {tCommon("actions.save")}
      </Button>
      <Button
        size="xs"
        radius="md"
        color="green"
        leftSection={<CheckIcon size={14} />}
        disabled={disabled}
        onClick={() => {
          modals.openConfirmModal({
            title: tCommon("confirm.title"),
            children: <Text size="sm">{t("form.confirmText")}</Text>,
            labels: { confirm: tCommon("confirm.confirm"), cancel: tCommon("confirm.back") },
            confirmProps: { color: "green" },
            centered: true,
            onConfirm: () => tryValidateAndSubmit(true),
          });
        }}
      >
        {tCommon("confirm.confirm")}
      </Button>
    </Flex>
  );
}
